import { observer } from 'mobx-react';
import { BUTTON_VARIANTS } from '../../../../../../../../components/inputs/button-variants';
import { FEDEX_EULA_ACCEPT_BUTTON_LABEL } from '../fedex-standard-eula';
import FedexV2RegistrationModalLayout from '../fedex-v2-registration-modal-layout';
import FedexV2RegistrationEulaStep from '../steps/fedex-v2-registration-eula-step';
import { IFedexV2RegistrationModalStepProps } from './fedex-v2-registration-modal-step-props';

const FedexV2RegistrationEulaModalStep: React.FC<IFedexV2RegistrationModalStepProps> = observer(({
    registration,
}) => (
    <FedexV2RegistrationModalLayout
        registration={registration}
        buttons={[{
            text: FEDEX_EULA_ACCEPT_BUTTON_LABEL,
            variant: BUTTON_VARIANTS.Primary,
            onClick: registration.acceptEula,
            disabled: !registration.eula.canAccept,
        }]}
    >
        <FedexV2RegistrationEulaStep eula={registration.eula} />
    </FedexV2RegistrationModalLayout>
));

export default FedexV2RegistrationEulaModalStep;
